const DEFAULT_SITE_DOMAIN = "www.reptrak.com";

// Inlined at build time (GATSBY_ prefix), so the same result renders on server and client.
const SITE_DOMAIN = process.env.GATSBY_PRIMARY_DOMAIN || DEFAULT_SITE_DOMAIN;

// Only http(s) and protocol-relative URLs can lead to another site. Relative paths,
// #anchors, mailto: and tel: never match, so they are left untouched.
const ABSOLUTE_URL = /^(https?:)?\/\//i;

// "www.reptrak.com" and "reptrak.com" are the same site (netlify.toml redirects one to the other).
const getHostname = (url: string) => {
  try {
    return new URL(url.replace(/^\/\//, "https://")).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
};

export const isExternalUrl = (uri?: string, siteDomain: string = SITE_DOMAIN) => {
  const url = uri?.trim();
  if (!url || !ABSOLUTE_URL.test(url)) return false;

  const hostname = getHostname(url);
  // The env var may be a bare host ("www.reptrak.com", "localhost:8088") or a full URL.
  const siteHostname = getHostname(ABSOLUTE_URL.test(siteDomain) ? siteDomain : `https://${siteDomain}`);

  return Boolean(hostname) && hostname !== siteHostname;
};

export const getExternalLinkProps = (uri?: string, siteDomain?: string) =>
  isExternalUrl(uri, siteDomain) ? { target: "_blank", rel: "nofollow noopener" } : {};
